import type { Identifier } from "ra-core";

import { getSupabaseClient } from "../providers/supabase/supabase";

/** Packlink PRO through the CRM server (the API key never reaches the browser). */

export const PACKLINK_APP_URL = "https://pro.packlink.es/private/shipments";

/** Shipments still waiting to be paid in Packlink can be deleted from the CRM. */
export const UNPAID_STATES = ["AWAITING_COMPLETION", "READY_TO_PURCHASE"];

const STATE_LABELS: Record<string, string> = {
  AWAITING_COMPLETION: "Pendiente de pagar en Packlink",
  READY_TO_PURCHASE: "Pendiente de pagar en Packlink",
  READY_TO_PRINT: "Pagado · imprime la etiqueta",
  READY_FOR_COLLECTION: "Listo para recogida",
  CARRIER_PENDING: "Pagado · esperando al transportista",
  CARRIER_OK: "Transportista confirmado",
  CARRIER_KO: "Error del transportista",
  LABELS_KO: "Error con la etiqueta",
  IN_TRANSIT: "En camino",
  DELIVERED: "Entregado",
  INCIDENT: "Incidencia",
  RETURNED_TO_SENDER: "Devuelto",
};

export const packlinkStateLabel = (state?: string | null) =>
  state ? (STATE_LABELS[state] ?? state) : "";

export const isPacklinkProblem = (state?: string | null) =>
  ["INCIDENT", "CARRIER_KO", "LABELS_KO", "RETURNED_TO_SENDER"].includes(
    state ?? "",
  );

export interface PacklinkOption {
  id: number;
  carrier: string;
  service: string;
  price: number;
  priceWithVat: number;
  transitHours: number | null;
  deliveryDate: string | null;
  pickup: boolean;
}

const call = async <T>(body: Record<string, unknown>): Promise<T> => {
  const { data, error } = await getSupabaseClient().functions.invoke<T>(
    "packlink",
    { method: "POST", body },
  );
  if (error || data == null) {
    let message = "Packlink no responde, prueba en un momento";
    try {
      const payload = await (error as { context?: Response })?.context?.json();
      if (payload?.message) message = payload.message;
    } catch {
      // keep the generic message
    }
    throw new Error(message);
  }
  return data;
};

export const quotePacklink = (orderId: Identifier) =>
  call<{ options: PacklinkOption[] }>({ action: "quote", order_id: orderId });

export const createPacklinkShipment = (
  orderId: Identifier,
  serviceId: number,
) =>
  call<{ reference: string }>({
    action: "create",
    order_id: orderId,
    service_id: serviceId,
  });

export const refreshPacklink = (orderId: Identifier) =>
  call<{
    state: string;
    /** not_shipped, in_transit, out_for_delivery, delivered, incident, returned */
    status: string;
    /** The order has just moved to "Recibido" */
    delivered: boolean;
    /** The installer got the parte because of this delivery */
    notified: boolean;
  }>({
    action: "refresh",
    order_id: orderId,
  });

export const cancelPacklink = (orderId: Identifier) =>
  call<{ cancelled: boolean }>({ action: "cancel", order_id: orderId });
